export const StatusModalBloquearDesbloquearEntrada = Object.freeze({
    CONFIRMACAO: 1,
    CARREGANDO: 2,
    SUCESSO: 3,
    ERRO: 4
});